/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DayInputs */

const cs_enum_day = /** @type {(inputs: Enum_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`den`)
};

const en_enum_day = /** @type {(inputs: Enum_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`day`)
};

/**
* | output |
* | --- |
* | "day" |
*
* @param {Enum_DayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_day = /** @type {((inputs?: Enum_DayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_day(inputs)
	return cs_enum_day(inputs)
});